import {createReducer, on} from '@ngrx/store';
import {ConfirmDialogState} from '../states/confirm-dialog.state';
import {ConfirmDialogActions} from '../actions/confirm-dialog.actions';

export const initialConfirmDialogState: ConfirmDialogState = {
  isOpen: false,
  title: '',
  text: '',
};

export const confirmDialogReducer = createReducer(
  initialConfirmDialogState,
  on(ConfirmDialogActions.open, (state, {title, text}) => ({
    ...state,
    isOpen: true,
    title,
    text,
  })),
  on(ConfirmDialogActions.close, state => ({
    ...state,
    isOpen: false,
  })),
);
